import posthog from 'posthog-js'

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'

let initialized = false

export function initPostHog() {
  if (initialized) return
  if (!POSTHOG_KEY) {
    console.warn('[PostHog] No API key found, analytics disabled')
    return
  }
  initialized = true

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    capture_exceptions: true,
    session_recording: {
      // Deliberately false, to keep typed values visible in replays for
      // debugging form problems.
      //
      // This FAILS OPEN: every input in the app is recorded verbatim unless it
      // opts out. rrweb masks type="password" on its own, but our password
      // fields have show/hide toggles that flip them to type="text", which
      // defeats that — so they carry `ph-no-capture` explicitly.
      //
      // Any new field holding a password, token, or anything else sensitive
      // MUST be given the `ph-no-capture` class. Nothing enforces this.
      maskAllInputs: false,
    },
  })
}

export { posthog }
